import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=01cc7af6&scoped=true&"
import script from "./deposit.vue?vue&type=script&lang=js&"
export * from "./deposit.vue?vue&type=script&lang=js&"
import style0 from "./deposit.vue?vue&type=style&index=0&id=01cc7af6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc7af6",
  null
  
)

export default component.exports